var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStarEmpty = function SvgStarEmpty(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "answer_icon_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-65.000000, -759.000000)",
    fill: "#020525",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.5030734,764.359396 L76.9374715,763.693778 L74.8968575,759.556276 C74.5312273,758.81879 73.4718426,758.809421 73.1030996,759.556276 L71.0624855,763.693778 L66.4968836,764.359396 C65.6781295,764.478139 65.3500053,765.487506 65.9437539,766.065629 L69.2468771,769.284372 L68.4656289,773.831236 C68.3250043,774.653133 69.1906028,775.268732 69.9156072,774.884364 L73.9999785,772.737488 L78.0843499,774.884364 C78.8093543,775.26562 79.6749528,774.653133 79.5343281,773.831236 L78.75308,769.284372 L82.0562032,766.065629 C82.6499518,765.487506 82.3218276,764.478139 81.5030734,764.359396 Z M77.1437088,768.759379 L77.8843382,773.084381 L73.9999785,771.043767 L70.1156189,773.084381 L70.8562482,768.759379 L67.7124874,765.696886 L72.0562271,765.065632 L73.9999785,761.128141 L75.94373,765.065632 L80.2874697,765.696886 L77.1437088,768.759379 Z",
    id: "answer_icon_1"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStarEmpty);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/star_empty.db3cf70169299033a8baa09be789ad1a.svg";